import { io } from "socket.io-client";
import { getApiUrl } from "./config";

export const socket = io(getApiUrl(), {
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  randomizationFactor: 0.5,
});
